import React, { useState } from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

type CarouselType = {
  images: IGatsbyImageData[];
};
const Carousel = ({ images }: CarouselType) => {
  const [currentindex, setCurrentIndex] = useState(0);

  const handlePrevios = () => {
    setCurrentIndex(currentindex === 0 ? images.length - 1 : currentindex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentindex === images.length - 1 ? 0 : currentindex + 1);
  };

  return (
    <div className="w-full  lg:max-w-4xl select-none relative">
      <div className="aspect-video">
        <GatsbyImage image={images[currentindex]} alt="project previews" />
      </div>
      <div className="flex justify-between items-center absolute w-full top-1/2 transform -translate-y-1/2 px-3">
        <button
          type="button"
          onClick={handlePrevios}
          className="rounded-full bg-deepBlack opacity-50 hover:opacity-70 "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 md:h-9 md:w-9"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          type="button"
          onClick={handleNext}
          className="rounded-full bg-deepBlack opacity-50 hover:opacity-70"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 md:h-9 md:w-9"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Carousel;
